import template from "./pFeatureFlags.html";
import featureFlags from "theme/utils/featureFlags.js";

export function pFeatureFlagsDirective() {
  'ngInject';

  let directive = {
    restrict: "E",
    template: template,
    controller: pFeatureFlagsController,
    controllerAs: 'pFeatureFlags',
    bindToController: true
  };

  return directive;
}

const manuallyProjectsFlag = "ProjectsSetManually";
const erpProjectsFlag = "ProjectsFromErpSystem";

class pFeatureFlagsController {
  constructor($interval, $routeParams, $scope, $translate, Admin, Auth, Notes, ConnectionQuality) {
    'ngInject';

    this.$interval = $interval;
    this.$routeParams = $routeParams;
    this.$scope = $scope;
    this.$translate = $translate;
    this.Admin = Admin;
    this.Auth = Auth;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;

    this.init();

    this.featureFlagsArray = featureFlags;

    this.rowActions = [
      {
        name: "edit",
        functionName: "startEditingFlags",
        fa: "fa-pencil-alt"
      }
    ];

    this.fields = {
      name: "info",
    };
    this.featureFlagsArray.forEach(flag => {
      this.fields[flag] = "checkbox";
    });

    this.editFlagValues = {};

    this.editFlagData = {
      name: {
        type: "text",
        editionDisabled: true
      }
    };
    this.featureFlagsArray.forEach(flag => {
      if (flag === "PartTimeVacation") {
        this.editFlagData[flag] = {
          type: "checkbox_reliant",
          reliantOn: "VacationReporting",
          isNotRequired: true
        };
      } else if (flag === "D365Integration") {
        this.editFlagData[flag] = {
          type: "checkbox_reliant",
          reliantOn: "Projects",
          isNotRequired: true
        };
      } else {
        this.editFlagData[flag] = {
          type: "checkbox",
          isNotRequired: true
        };
      }
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;
        if (!this.user.isAdmin) {
          this.Auth.handleUnauthorized();
        }
        this.Admin.getCountries().then(
          (countries) => {
            this.countries = countries.data;
            this.featureFlags = [];

            this.countries.forEach((country,i) => {
              this.featureFlags.push({
                name: country.name
              });

              this.featureFlagsArray.forEach( flag => {
                if (flag === "Projects") {
                  const isProjectFlag = !!country.flags.find(flag => flag === manuallyProjectsFlag || flag === erpProjectsFlag);
                  if(isProjectFlag)
                    this.featureFlags[i][flag] = true;
                  else
                    this.featureFlags[i][flag] = false;
                } else if (flag === 'OvertimeRequest') {
                  if(country.flags.indexOf("OvertimeApplications") > -1)
                    this.featureFlags[i][flag] = true;
                  else
                    this.featureFlags[i][flag] = false;
                } else {
                  if(country.flags.indexOf(flag) > -1)
                    this.featureFlags[i][flag] = true;
                  else
                    this.featureFlags[i][flag] = false;
                }
              });
            });

            var timeout = this.$interval(() => {
              this.notes = this.Notes.getNotes();
            }, 10);
            this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});

            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  startEditingFlags(country) {
    this.editFlagProcess = true;
    this.editFlagValues = angular.copy(country);
    const countryFlags = this.countries.find(c => c.name === country.name).flags;
    this.projectsFlag = countryFlags && countryFlags.find(flag => flag === manuallyProjectsFlag || flag === erpProjectsFlag);
  }

  updateFlag(flags) {
    if (this.state == 'loading')
    return;

    this.state = 'loading';
    let country = {
      name: flags.name,
      flags: []
    };
    this.featureFlagsArray.forEach( flag => {
      if(flags[flag] && flag === "Projects") {
        const flagToSend = this.projectsFlag || manuallyProjectsFlag;
        country.flags.push(flagToSend);
      } else if (flags[flag] && flag !== "Projects") {
        if (flag === 'OvertimeRequest')
          country.flags.push("OvertimeApplications");
        else
          country.flags.push(flag);
      }
    });

    this.Admin.updateCountry(flags.name, country).then(
      () => {
        this.editFlagProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }
}